import { SectionShell } from "@/components/design-system/SectionShell";
import { Button } from "@/components/ui/button";
import { useToast } from "@/components/Toaster";

const code = `import { useToast } from "@/components/Toaster";

const notify = useToast();

notify({ title: "Deck created", body: "Add your first card below." });
notify({ title: "Couldn't save that", tone: "error" });`;

export function ToastSection() {
  const notify = useToast();

  return (
    <SectionShell
      id="toast"
      title="Toast"
      description={
        <>
          A small panel that slides in at the bottom right, clear of a page's action buttons. Rails flash messages
          (<code>notice</code> and <code>alert</code>) become toasts
          automatically, so controllers keep using <code>redirect_to … notice:</code>.
          Notices fade after five seconds; errors stay until dismissed.
        </>
      }
      whenToUse={
        <ul>
          <li>Confirming something that just happened ("Settings saved").</li>
          <li>Reporting a failure that isn't tied to one field.</li>
        </ul>
      }
      whenNotToUse={
        <ul>
          <li>Field validation — show the error beside the field.</li>
          <li>Anything the person must read or act on — put it on the page.</li>
        </ul>
      }
      preview={
        <div className="flex flex-wrap gap-3">
          <Button
            variant="secondary"
            onClick={() => notify({ title: "Settings saved", body: "Your exam details were updated." })}
          >
            Show a notice
          </Button>
          <Button variant="secondary" onClick={() => notify({ title: "Couldn't save that", tone: "error" })}>
            Show an error
          </Button>
        </div>
      }
      code={code}
      options={
        <ul className="list-disc pl-5">
          <li><code>tone</code>: <code>success</code> (default) | <code>error</code></li>
          <li><code>body</code> adds a second, quieter line.</li>
        </ul>
      }
    />
  );
}
